import { render, staticRenderFns } from "./UnauthenticatedUserFollowProjectModal.vue?vue&type=template&id=0152324e"
import script from "./UnauthenticatedUserFollowProjectModal.vue?vue&type=script&lang=js"
export * from "./UnauthenticatedUserFollowProjectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports